const OperatorGroup = Object.freeze({
  VALUE: 'value',
  NUMBER: 'number',
  DATE: 'date',
  BOOL: 'bool',
  TEXT: 'text',
  ARRAY: 'array',
  OBJECT: 'object'
})

const TagTypeOperatorGroups = Object.freeze({
  0: [OperatorGroup.VALUE, OperatorGroup.TEXT], // TYPE_STRING
  1: [OperatorGroup.VALUE, OperatorGroup.NUMBER], // TYPE_UNENFORCED_NUMBER
  2: [OperatorGroup.VALUE, OperatorGroup.DATE], // TYPE_UNENFORCED_DATE
  3: [OperatorGroup.VALUE, OperatorGroup.ARRAY, OperatorGroup.OBJECT], // TYPE_UNENFORCED_JSON
  4: [OperatorGroup.VALUE, OperatorGroup.BOOL], // TYPE_BOOLEAN
  5: [OperatorGroup.VALUE, OperatorGroup.NUMBER], // TYPE_NUMBER
  6: [OperatorGroup.VALUE, OperatorGroup.NUMBER], // TYPE_INTEGER
  7: [OperatorGroup.VALUE, OperatorGroup.DATE], // TYPE_DATE
  8: [OperatorGroup.VALUE, OperatorGroup.DATE], // TYPE_DATETIME
  9: [OperatorGroup.VALUE, OperatorGroup.ARRAY], // TYPE_ARRAY
  10: [OperatorGroup.VALUE, OperatorGroup.OBJECT] // TYPE_OBJECT
})

const OperatorGroupMap = Object.freeze({
  '=': OperatorGroup.VALUE,
  '!=': OperatorGroup.VALUE,
  in: OperatorGroup.VALUE,
  'not in': OperatorGroup.VALUE,
  'is set': OperatorGroup.VALUE,
  'not set': OperatorGroup.VALUE,
  '>': OperatorGroup.NUMBER,
  '<': OperatorGroup.NUMBER,
  '>=': OperatorGroup.NUMBER,
  '<=': OperatorGroup.NUMBER,
  between: OperatorGroup.NUMBER,
  'not between': OperatorGroup.NUMBER,
  'date is': OperatorGroup.DATE,
  'datetime is': OperatorGroup.DATE,
  'anniversary is': OperatorGroup.DATE,
  true: OperatorGroup.BOOL,
  false: OperatorGroup.BOOL,
  'begins with': OperatorGroup.TEXT,
  'not begins with': OperatorGroup.TEXT,
  'ends with': OperatorGroup.TEXT,
  'not ends with': OperatorGroup.TEXT,
  contains: OperatorGroup.TEXT,
  'not contains': OperatorGroup.TEXT,
  'contains object': OperatorGroup.ARRAY,
  'not contains object': OperatorGroup.ARRAY,
  'contains value': OperatorGroup.ARRAY,
  'not contains value': OperatorGroup.ARRAY,
  'contains any of': OperatorGroup.ARRAY,
  'contains none of': OperatorGroup.ARRAY,
  'contains item': OperatorGroup.ARRAY,
  'contains item with property': OperatorGroup.ARRAY,
  'contains property': OperatorGroup.OBJECT
})

export { OperatorGroup, TagTypeOperatorGroups, OperatorGroupMap }



// WEBPACK FOOTER //
// ./src/modules/segment/enum/OperatorGroupEnum.js